import { AdminRole } from '../types';

const DEFAULT_SUPER_ADMIN_EMAILS = [
  'nicolasdreny@gmail.com',
  'admin@cameroonlandmarket.com',
  'ads@cameroonlandmarket.com',
  'support@cameroonlandmarket.com',
  'superadmin@cameroonlandmarket.com',
];

const DEFAULT_LISTING_ADMIN_EMAILS = [
  'listingadmin@cameroonlandmarket.com',
];

const env: any = (typeof import.meta !== 'undefined' && (import.meta as any).env) || (typeof process !== 'undefined' && process.env) || {};
const configuredSuperAdmin = (env.VITE_SUPER_ADMIN_EMAILS as string | undefined) ||
  (env.VITE_SUPER_ADMIN_EMAIL as string | undefined);
const configuredListingAdmin = (env.VITE_LISTING_ADMIN_EMAILS as string | undefined) ||
  (env.VITE_LISTING_ADMIN_EMAIL as string | undefined);

export const SUPER_ADMIN_EMAILS: string[] = Array.from(
  new Set([
    ...DEFAULT_SUPER_ADMIN_EMAILS,
    ...(configuredSuperAdmin
      ? configuredSuperAdmin.split(',').map((e: string) => e.trim().toLowerCase()).filter(Boolean)
      : []),
  ])
);

export const LISTING_APPROVAL_ADMIN_EMAILS: string[] = Array.from(
  new Set([
    ...DEFAULT_LISTING_ADMIN_EMAILS,
    ...(configuredListingAdmin
      ? configuredListingAdmin.split(',').map((e: string) => e.trim().toLowerCase()).filter(Boolean)
      : []),
  ])
);

export function isDesignatedAdminEmail(email?: string | null): boolean {
  if (!email) return false;
  const clean = email.trim().toLowerCase();
  return (
    SUPER_ADMIN_EMAILS.includes(clean) ||
    LISTING_APPROVAL_ADMIN_EMAILS.includes(clean) ||
    clean.endsWith('@cameroonlandmarket.com')
  );
}

export function getDefaultRoleForEmail(email?: string | null): AdminRole {
  if (!email) return 'Listing Approval Admin';
  const clean = email.trim().toLowerCase();
  if (SUPER_ADMIN_EMAILS.includes(clean)) return 'Super Admin';
  if (LISTING_APPROVAL_ADMIN_EMAILS.includes(clean)) return 'Listing Approval Admin';
  return 'Listing Approval Admin';
}
